import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { MatCheckboxChange } from '@angular/material';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardComponent implements OnInit {
  @Input()
  title: string;

  @Input()
  image: string;

  @Input()
  defaultImage = '/assets/images/card-thumbnail-placeholder.png';

  @Input()
  checked: boolean;

  @Input()
  checkable = false;

  @Input()
  showHover = true;

  @Output()
  checkedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
  ) { }

  ngOnInit() {
  }

  handleCheckedChange(change: MatCheckboxChange) {
    this.checkedChange.emit(change.checked);
  }
}
